module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAJBJREFUOE9jZKASYKSSOQyD3KC5MdLLGRmYItC8+yJpyWNJQkGA4rV5MTL7GRgYHdA1/Wf4v4PhP+MLZHFGhr87kpY+WwkTQzFoboy0PiMjowAh20Hy/////5C85OlFrAbhchF2g/8fSFryxHHUIHzBTo8wwpEgsTrrP8O/FclLnkZijTVi0g8uNYM801LiNQDj0EMTLATOLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SearchPage/folder.png
// module id = yhrZ
// module chunks = 1